import {
  gql,
  skipToken,
  SuspenseQueryHookFetchPolicy,
  useSuspenseQuery,
} from '@apollo/client';

import { useGetSessionCompany } from '../../../common/hooks/useGetSessionCompany';
import { BaseEmployerInput } from '../../../common/interfaces/entities';
import { CompanyCreditInfo } from '../types';

const query = gql`
  query getCompanyCreditInfo($input: GetCompanyCreditInfoInput!) {
    getCompanyCreditInfo(input: $input) {
      ...companyCreditInfoFragment
    }
  }
`;

type GetCompanyCreditInventoryVariables = {
  input: BaseEmployerInput;
};

type GetCompanyCreditInventoryResponse = {
  getCompanyCreditInfo?: CompanyCreditInfo;
};

export const useGetCompanyCreditInventorySuspenseQuery = (
  fetchPolicy: SuspenseQueryHookFetchPolicy = 'cache-and-network'
) => {
  const { sessionCompany } = useGetSessionCompany();

  const companyId = sessionCompany?.id;

  const companyInput = {
    companyId: companyId || '',
  };
  const { data, refetch } = useSuspenseQuery<
    GetCompanyCreditInventoryResponse,
    GetCompanyCreditInventoryVariables
  >(
    query,
    companyId
      ? {
          variables: {
            input: companyInput,
          },
          fetchPolicy,
        }
      : skipToken
  );

  const defaultData: CompanyCreditInfo = {
    totalAmount: 0,
    nextExpiringCredit: null,
  };

  return {
    data: data?.getCompanyCreditInfo || defaultData,
    refetchGetCompanyCreditInventory: refetch,
  } as const;
};
